import type { ReactNode } from 'react'

export function RequiredMark() {
  return <span className="text-[#ff0011] text-[13px]"> *</span>
}

interface RequiredCaptionProps {
  errorData: Record<string, string | null | undefined>
  field: string
  width?: string
}

export function RequiredCaption({ errorData, field, width }: RequiredCaptionProps): ReactNode {
  if (!errorData?.[field]) return null

  return (
    <div
      className="absolute bottom-[-12px] text-[11px] font-normal leading-[11px] text-red-500 whitespace-normal"
      style={{ width: width ?? '100%' }}
    >
      {errorData[field]}
    </div>
  )
}
